import { API_URLS } from "@constants";
import * as G from "@globals";
import * as Q from "./queries";



export const gql = async <K extends keyof typeof Q>( queryName: K, ...args: Parameters<typeof Q[K]>) => {

	const { address } = G.wallet.getBracketWallet();
	const { GRAPHQL_API } = API_URLS;
	const headers: HeadersInit = { "Content-Type": "application/json", ...(address ? { wallet: address, } : {}), };

	// biome-ignore lint/performance/noDynamicNamespaceImportAccess:  interesting, but it works for now... another time.
	const queryFn = Q[queryName];
	// biome-ignore lint/suspicious/noExplicitAny: this is not worth the effort of explaining to typescript the generics... another time.
	const query = (queryFn as any)(...args);
	const body = JSON.stringify({ query, });

	const response = await fetch(GRAPHQL_API, { method: "POST", body, headers, });
	if(response.ok) {
		const { data } = await response.json();
		return data;
	}
	throw new Error("graphql query has failed.");
};
